import { createApp, reactive } from 'vue';
import App from "./App.vue";
import router from './router';
import store from './store';
import './main.scss';
import registerGlobalComponents from '@/utils/registerGlobalComponents';
import { createGtm } from '@gtm-support/vue-gtm';
import vueDebounce from 'vue-debounce';

import "@nova/ui/styles";
import "@nova/ui/fonts/300";

const app = createApp(App);
registerGlobalComponents(app);
if(process.env.VUE_APP_GOOGLE_ANALYTICS_GTM_ID) {
  app.use(
    createGtm({
      id: process.env.VUE_APP_GOOGLE_ANALYTICS_GTM_ID, // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      trackOnNextTick: true // Whether or not call trackView in Vue.nextTick
    })
  );
}


app.use(vueDebounce, {
  defaultTime: '300ms',
});

const contactType = reactive({ contactType: "common" });
Object.defineProperty(app.config.globalProperties, '$contactType', {
  get () {
    return contactType.contactType
  },
  set (value) {
    contactType.contactType = value;
  }
});

app.config.productionTip = false;
app.config.globalProperties.toggle = false;
app.use(router);
app.use(store);

app.mount('#app');